var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08979 14.0834C2.67424 14.0834 2.31924 13.9362 2.02479 13.6419C1.73049 13.3475 1.58333 12.9925 1.58333 12.5769V2.00002H0.75V0.750023H4.5V0.0129395H9.5V0.750023H13.25V2.00002H12.4167V12.5769C12.4167 12.9979 12.2708 13.3542 11.9792 13.6459C11.6875 13.9375 11.3312 14.0834 10.9102 14.0834H3.08979ZM11.1667 2.00002H2.83333V12.5769C2.83333 12.6518 2.85736 12.7132 2.90542 12.7613C2.95347 12.8093 3.01493 12.8334 3.08979 12.8334H10.9102C10.9744 12.8334 11.0331 12.8066 11.0865 12.7531C11.1399 12.6998 11.1667 12.6411 11.1667 12.5769V2.00002ZM4.83667 11.1667H6.08646V3.66669H4.83667V11.1667ZM7.91354 11.1667H9.16333V3.66669H7.91354V11.1667Z",
    fill: "#5F6376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fd5363f0351a362c74693d467dbc2e75.svg";
export { ForwardRef as ReactComponent };